import React, { lazy } from 'react'
import { DomainRoute } from 'domains/insights-portal/utils/domain/routingComponents'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { FilterParamsProvider } from 'domains/insights-portal/utils/filter-params/FilterParamsProvider'
import { DataExplorerParamsProvider } from 'domains/insights-portal/components/data-explorer/utils/filter-params/DataExplorerParamsProvider'
import { insightsPortalAdsDashboardAccessControl } from 'domains/insights-portal/access-control/insightsPortalAdsDashboardAccess.configuration'
import { insightsPortalAccessControl } from 'domains/insights-portal/access-control/insightsPortalAccess.configuration'
import { insightsPortalSummaryReportAccessControl } from 'domains/insights-portal/access-control/insightsPortalSummaryReportAccess.configuration'
import { insightsPortalDataExplorerAccessControl } from 'domains/insights-portal/access-control/insightsPortalDataExplorerAccess.configuration'
import { insightsPortalAdsCampaignAccessControl } from 'domains/insights-portal/access-control/insightsPortalAdsCampaignAccess.configuration'
import { insightsPortalCampaignAnalyticsAccessControl } from 'domains/insights-portal/access-control/insightsPortalCampaignAnalytics.configuration'
import { insightsPortalInventoryIntelligenceAccessControl } from 'domains/insights-portal/access-control/insightsPortalInventoryIntelligence.configuration'
import { insightsPortalCollectionsControl } from 'domains/insights-portal/access-control/insightsPortalCollections.configuration'
import { insightsPortalPlacementsAccessControl } from 'domains/insights-portal/access-control/insightsPortalPlacements.configuration'

const InsightsPortalPerformanceDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalPerformanceDashboardPage" */
      'domains/insights-portal/pages/performance-dashboard/InsightsPortalPerformanceDashboardPage'
    )
)
const InsightsPortalOutOfStockDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalOutOfStockDashboardPage" */
      'domains/insights-portal/pages/out-of-stock-dashboard/InsightsPortalOutOfStockDashboardPage'
    )
)
const InsightsPortalBasketDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalBasketDashboardPage" */
      'domains/insights-portal/pages/basket-dashboard/InsightsPortalBasketDashboardPage'
    )
)
const InsightsPortalSearchDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalSearchDashboardPage" */
      'domains/insights-portal/pages/search-dashboard/InsightsPortalSearchDashboardPage'
    )
)

const InsightsPortalSummaryReportPdfPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalSummaryReportPdfPage" */
      'domains/insights-portal/pages/summary-report-pdf/InsightsPortalSummaryReportPdfPage'
    )
)
const InsightsPortalDataExplorerPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalDataExplorerPage" */
      'domains/insights-portal/pages/data-explorer/InsightsPortalDataExplorerPage'
    )
)
const InsightsPortalAdsCampaignPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalAdsCampaignPage" */
      'domains/insights-portal/pages/ads-campaign/InsightsPortalAdsCampaignPage'
    )
)
const InsightsPortalInventoryIntelligencePage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalInventoryIntelligence" */
      'domains/insights-portal/pages/inventory-intelligence/InsightsPortalInventoryIntelligencePage'
    )
)
const InsightsPortalNewReportPreviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalReportPreviewPage" */
      'domains/insights-portal/pages/report-preview/InsightsPortalNewReportPreviewPage'
    )
)
const InsightsPortalCustomReportListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalCustomReportListPage" */
      'domains/insights-portal/pages/custom-report-list/InsightsPortalCustomReportListPage'
    )
)
const InsightsPortalAdsDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalAdsDashboardPage" */
      'domains/insights-portal/pages/ads-dashboard/InsightsPortalAdsDashboardPage'
    )
)
const InsightsPortalExistingReportPreviewPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalExistingReportPreviewPage" */
      'domains/insights-portal/pages/report-preview/InsightsPortalExistingReportPreviewPage'
    )
)
const InsightsPortalPerformancePage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalPerformancePage" */
      'domains/insights-portal/pages/performance/InsightsPortalPerformancePage'
    )
)
const InsightsPortalExecutiveSummaryPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalExecutiveSummaryPage" */
      'domains/insights-portal/pages/executive-summary/InsightsPortalExecutiveSummaryPage'
    )
)
const InsightsPortalCampaignsAnalyticsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalCampaignsAnalyticsPage" */
      'domains/insights-portal/pages/campaigns-analytics/InsightsPortalCampaignsAnalyticsPage'
    )
)
const InsightsPortalCampaignsGeographyPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalCampaignsGeographyPage" */
      'domains/insights-portal/pages/campaigns-geography/InsightsPortalCampaignsGeographyPage'
    )
)
const InsightsPortalCollectionsInsightsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalCollectionsInsightsPage" */
      'domains/insights-portal/pages/collections-insights/InsightsPortalCollectionsInsightsPage'
    )
)
const InsightsPortalPlacementsInsightsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "InsightsPortalPlacementsInsightsPage" */
      'domains/insights-portal/pages/placements-insights/InsightsPortalPlacementsInsightsPage'
    )
)
// @hygen:inject page-import

export const insightsPortalRouter = (
  <DomainRoute route="insights-portal">
    <FilterParamsProvider>
      <DataExplorerParamsProvider>
        <DashSwitch>
          <DomainRoute
            exact
            route="insights-portal-performance-dashboard"
            component={InsightsPortalPerformanceDashboardPage}
            accessControl={insightsPortalAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-out-of-stock-dashboard"
            component={InsightsPortalOutOfStockDashboardPage}
            accessControl={insightsPortalAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-basket-dashboard"
            component={InsightsPortalBasketDashboardPage}
            accessControl={insightsPortalAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-search-dashboard"
            component={InsightsPortalSearchDashboardPage}
            accessControl={insightsPortalAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-ads-campaign"
            component={InsightsPortalAdsCampaignPage}
            accessControl={insightsPortalAdsCampaignAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-ads-dashboard"
            component={InsightsPortalAdsDashboardPage}
            accessControl={insightsPortalAdsDashboardAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-inventory-intelligence"
            component={InsightsPortalInventoryIntelligencePage}
            accessControl={insightsPortalInventoryIntelligenceAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-summary-report-pdf"
            component={InsightsPortalSummaryReportPdfPage}
            // access control for insights-portal-summary-report and insights-portal-summary-report-pdf should stay the same
            accessControl={insightsPortalSummaryReportAccessControl}
          />
          <DomainRoute route="insights-portal-custom-report">
            <DomainRoute
              exact
              route="insights-portal-data-explorer"
              component={InsightsPortalDataExplorerPage}
              accessControl={insightsPortalDataExplorerAccessControl}
            />
            <DomainRoute
              exact
              route="insights-portal-report-preview-new"
              component={InsightsPortalNewReportPreviewPage}
              accessControl={insightsPortalDataExplorerAccessControl}
            />
            <DomainRoute
              exact
              route="insights-portal-report-preview-existing"
              component={InsightsPortalExistingReportPreviewPage}
              accessControl={insightsPortalDataExplorerAccessControl}
            />
            <DomainRoute
              exact
              route="insights-portal-custom-report-list"
              component={InsightsPortalCustomReportListPage}
              accessControl={insightsPortalDataExplorerAccessControl}
            />
          </DomainRoute>
          <DomainRoute
            route="insights-portal-performance"
            component={InsightsPortalPerformancePage}
            accessControl={insightsPortalAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-executive-summary"
            component={InsightsPortalExecutiveSummaryPage}
          />
          <DomainRoute
            route="insights-portal-campaigns-analytics"
            component={InsightsPortalCampaignsAnalyticsPage}
            accessControl={insightsPortalCampaignAnalyticsAccessControl}
          />
          <DomainRoute
            exact
            route="insights-portal-campaigns-geography"
            component={InsightsPortalCampaignsGeographyPage}
            accessControl={insightsPortalCampaignAnalyticsAccessControl}
          />
          <DomainRoute
            route="insights-portal-collections-insights"
            component={InsightsPortalCollectionsInsightsPage}
            accessControl={insightsPortalCollectionsControl}
          />
          <DomainRoute
            route="insights-portal-placements-insights"
            component={InsightsPortalPlacementsInsightsPage}
            accessControl={insightsPortalPlacementsAccessControl}
          />
          {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
        </DashSwitch>
      </DataExplorerParamsProvider>
    </FilterParamsProvider>
  </DomainRoute>
)
